import React from "react";
import styled, { css } from "styled-components";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Col, Row } from "components/bootstrap";
import { Section, StatusIcon } from "components/common";
import {
  RotationStrategySummary,
  RetentionStrategySummary
} from "components/indices/IndexMaintenanceStrategiesSummary";
import {
  DataTieringSummary,
  DATA_TIERING_TYPE,
  prepareDataTieringInitialValues,
  DataTieringVisualisation
} from "components/indices/data-tiering";
import usePluginEntities from "hooks/usePluginEntities";
const FlexWrapper = styled(Col)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};

    dl {
      margin-bottom: 0;
    }

    dl > dt {
      width: 240px;
      float: left;
      clear: left;
      margin-right: ${theme.spacings.xs};
    }

    dl > dd {
      margin-bottom: ${theme.spacings.sm};
    }

    dl > dd:last-child {
      margin-bottom: 0;
    }
  `
);
const RotationSummaryWrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
  `
);
const WarmTierSummaryWrapper = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.spacings.sm};
  `
);
const Grid = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: ${theme.spacings.md};
  `
);
const formatRefreshInterval = (intervalInMs) => {
  const intervalInSeconds = intervalInMs / 1e3;
  if (intervalInSeconds > 60) {
    return `${intervalInSeconds / 60} minutes`;
  }
  return `${intervalInSeconds} seconds`;
};
const TemplateDetails = ({ template, showDescription = false }) => {
  const dataTieringPlugins = usePluginEntities("dataTiering");
  const dataTieringPlugin = dataTieringPlugins.find((plugin) => plugin.type === DATA_TIERING_TYPE.HOT_WARM);
  const dataTieringConfig = prepareDataTieringInitialValues(template.index_set_config.data_tiering, PluginStore, false);
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(FlexWrapper, { md: 12 }, !template.index_set_config.use_legacy_rotation && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    DataTieringVisualisation,
    {
      minDays: dataTieringConfig.index_lifetime_min,
      maxDays: dataTieringConfig.index_lifetime_max,
      minDaysInHot: dataTieringConfig.index_hot_lifetime_min,
      warmTierEnabled: dataTieringConfig.warm_tier_enabled,
      archiveData: dataTieringConfig.archive_before_deletion
    }
  ))), template.description && showDescription && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Section, { title: "Description" }, /* @__PURE__ */ React.createElement("p", null, template.description)))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(Section, { title: "Details" }, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Index Analyzer:"), /* @__PURE__ */ React.createElement("dd", null, template.index_set_config.index_analyzer), /* @__PURE__ */ React.createElement("dt", null, "Index Shards:"), /* @__PURE__ */ React.createElement("dd", null, template.index_set_config.shards), /* @__PURE__ */ React.createElement("dt", null, "Index Replica:"), /* @__PURE__ */ React.createElement("dd", null, template.index_set_config.replicas), /* @__PURE__ */ React.createElement("dt", null, "Maximum Number of Segments:"), /* @__PURE__ */ React.createElement("dd", null, template.index_set_config.index_optimization_max_num_segments), /* @__PURE__ */ React.createElement("dt", null, "Index Optimization after Rotation:"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: !template.index_set_config.index_optimization_disabled })), /* @__PURE__ */ React.createElement("dt", null, "Field Type Refresh Interval:"), /* @__PURE__ */ React.createElement("dd", null, formatRefreshInterval(template.index_set_config.field_type_refresh_interval)))), /* @__PURE__ */ React.createElement(Section, { title: "Rotation & Retention" }, template.index_set_config.use_legacy_rotation ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RotationSummaryWrapper, null, /* @__PURE__ */ React.createElement(
    RotationStrategySummary,
    {
      config: {
        strategy: template.index_set_config.rotation_strategy_class,
        config: template.index_set_config.rotation_strategy
      }
    }
  )), /* @__PURE__ */ React.createElement(
    RetentionStrategySummary,
    {
      config: {
        strategy: template.index_set_config.retention_strategy_class,
        config: template.index_set_config.retention_strategy
      },
      rotationStrategyClass: template.index_set_config.rotation_strategy_class
    }
  )) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DataTieringSummary, { config: template.index_set_config.data_tiering }), dataTieringPlugin && /* @__PURE__ */ React.createElement(WarmTierSummaryWrapper, null, /* @__PURE__ */ React.createElement(dataTieringPlugin.TiersSummary, { config: template.index_set_config.data_tiering })))))))));
};
export default TemplateDetails;
